import { DatosReporte, EstrategiaReporte, Reporte, ReporteRegistrado } from './reporte';

export interface DatosServicioReportes<TCodigo extends string = string> {
    codigo: TCodigo;
    nombre: string;
    ruta: string;
    icono?: string;
    permiso: string;
    actualizacionMasiva?: boolean;
}

export type RegistroDatosReportes = Record<string, DatosReporte>;

export type EstrategiasReportes<TDatos extends RegistroDatosReportes> = {
    [TId in keyof TDatos]: EstrategiaReporte<any, any>;
};

export class ServicioReportes<TCodigo extends string = string, TDatos extends RegistroDatosReportes = RegistroDatosReportes> {
    private readonly reportes: Map<Extract<keyof TDatos, string>, ReporteRegistrado<TDatos[keyof TDatos]>>;

    constructor(
        readonly datos: DatosServicioReportes<TCodigo>,
        definiciones: TDatos,
        estrategias: EstrategiasReportes<TDatos>
    ) {
        const registros = Object.keys(definiciones).map((id) => {
            const tipo = id as Extract<keyof TDatos, string>;
            const reporte = new Reporte(tipo, definiciones[tipo], estrategias[tipo]);
            return [tipo, reporte] as const;
        });

        this.reportes = new Map(registros);
    }

    obtener(id: string | null | undefined): ReporteRegistrado<TDatos[keyof TDatos]> | null {
        if (!id) {
            return null;
        }

        return this.reportes.get(id as Extract<keyof TDatos, string>) ?? null;
    }

    listar(): ReporteRegistrado<TDatos[keyof TDatos]>[] {
        return [...this.reportes.values()];
    }

    primero(): ReporteRegistrado<TDatos[keyof TDatos]> | null {
        return this.listar()[0] ?? null;
    }

    buscarPorCodigoJob(codigo: string): ReporteRegistrado<TDatos[keyof TDatos]> | null {
        const normalizado = this.normalizar(codigo);
        return this.listar().find((reporte) => this.normalizar(reporte.codigoJob) === normalizado) ?? null;
    }

    private normalizar(valor: string): string {
        return valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    }
}

export type ServicioReportesRegistrado = ServicioReportes<string, RegistroDatosReportes>;
